import { Investigation } from "../../lusca-search-api/generated-src";

/** True for a case split off by a list (R22): it never gains items. */
export const isListPopulation = (investigation?: Investigation | null) =>
  investigation?.population?.source === "list";

/**
 * One short line under the status card suggesting the next status (R22.8), or null. Owner only,
 * never a banner: it answers "which status do I pick?" without adding a step.
 */
export const statusHint = (
  investigation: Investigation,
  isOwner: boolean
): string | null => {
  if (!isOwner) return null;
  switch (investigation.status) {
    case "INVESTIGATING":
      if (isListPopulation(investigation))
        return "Items settled? Move to Ready to redrive to redrive or delete them.";
      return (investigation.assignedCount ?? 0) > 1
        ? "Waiting on a code fix? Use Fix in progress, or Blocked with the ticket. Items need different handling? More → Split by list."
        : "Waiting on a code fix? Use Fix in progress, or Blocked with the ticket.";
    case "FIX_IN_PROGRESS":
      return "Fix deployed? Move to Ready to redrive.";
    case "BLOCKED":
      return "Unblocked? Move back to Fix in progress or Ready to redrive.";
    default:
      return null;
  }
};
